module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP21.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP21"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.20.0.0.box.610.655.371.34.q.100"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP21.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.20.0.0.box.610.655.371.34.q.100"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.20.1.0.box.572.756.447.40.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP21.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.20.1.0.box.572.756.447.40.q.70"
    }
  }, [_vm._v("By "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Harnett ")]), _vm._v("T. "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Kane ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.20.2.0.box.135.857.1323.295.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP21.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-style": "italic"
    },
    attrs: {
      "id": "para.20.2.0.box.135.857.1323.295.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP21.w.2.0.0"
    }
  }), _vm._v("(Nationally ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("known ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("New ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Orleans ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("writer, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("author ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("twenty")]), _c('i', [_vm._v("-three ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("best ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sellers, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("which ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("have ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("reached ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("several ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("million ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("copies, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("including ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\"Plantation ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Parade,\" ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\"Natchez,\" ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\"Gone ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Are ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Days,\" ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\"Bride ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Fortune,\" ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\"Lady ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Arlington,\" ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\"Gallant ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Mrs. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Stonewall,\" ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\"Queen ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("New ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Orleans,\" ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\"Louisiana ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Hayride\" ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("others.) ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.20.3.0.box.130.1212.1327.1070.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP21.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.3.0.box.135.1212.1322.321.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP21.w.3.0.0"
    }
  }), _vm._v("Some years ago, I was fortunate in that William E. Clement permitted me to see in manuscript form his lively and authoritative \"Plantation Life on the Mississippi.\" Since then, on a number of occasions, I have reread this volume and consulted it for verification of many details in the writing of a number of my books, magazine and other writings.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP21.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.3.1.box.132.1558.1323.262.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP21.w.3.1.0"
    }
  }), _vm._v("Mr. Clement understands, out of intimate experience and long, full observation, the scene and the people of whom he writes. He has had a unique opportunity to study the rich subject, and he has taken happy advantage of his opportunity. We, his readers, are the beneficiaries of that situation.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP21.w.3.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.3.2.box.131.1844.1323.200.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP21.w.3.2.0"
    }
  }), _vm._v("He does not over-elaborate, over-tell, or over-burden the meaningful story that he gives. In the simplicity of his volume there is perhaps its greatest conviction, its strongest effect.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP21.w.3.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.3.3.box.130.2076.1322.206.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP21.w.3.3.0"
    }
  }), _vm._v("William E. Clement describes the Roosevelt family's pioneering Mississippi River steamboat and its epochal arrival in New Orleans in the 1812 period. He tells of one of his forebears, Samuel Clement, captain of the third steam vessel on"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP22.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.21.0.0.box.130.273.1323.379.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP22"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP22.w.0.0.0"
    }
  }), _vm._v("\nthe great stream; of Samuel Clement's role in the dramatic fighting at the Battle of New Orleans. The author also offers vivid details of the tragic duel between Andrew Jackson and Charles Dickinson — one of the harshest of all American meetings on the so-called \"field of honor.\" And Mr. Clement contributes an impressive account of the \"Last Island\" storm, which Lafcadio Hearn gave to the world in his \"Chita.\"")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP22.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP22"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.21.0.0.box.130.273.1327.931.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP22.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.0.1.box.143.678.1314.526.q.60"
    }
  }, [_vm._v("But above all this volume offers a fascinating portrayal of daily life in the Louisiana Sugar Bowl of the Reconstruction era. As Mr. Clement portrays it, the tempestuous period also had hours of quiet and simple plantation existence. For several years I have retained a vivid memory of Mr. Clement's loving recreation of those days in the sugar area of Iberville parish and its environs. Rereading the book in recent weeks, I have been newly impressed with it. It has a flavor that is very much "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sui ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("generis, ")]), _vm._v("unlike that of any other that has been written on Louisiana.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55bdb5bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0012.vue
// module id = 63
// module chunks = 0